import { Box, Button, Grid } from "@mui/material";

export interface SearchActionsProps {
    onSubmitHandler: () => void | Promise<void>;
    onCancelHandler: () => void;
    style?: React.CSSProperties;
    /** "Search" by default */
    customSubmitName?: string;
    /** "Clear" by default */
    customCancelName?: string;
}

const SearchActions = (props: SearchActionsProps) => {
    return (
        <Box sx={props.style ? props.style : { margin: "2rem 0 2rem 0" }}>
            <Grid container justifyContent="center" alignItems="center" sx={{ width: "300px", margin: "0 auto" }}>
                <Grid container justifyContent={"center"}>
                    <Grid item xs={5} md={5} xl={5} textAlign="center">
                        <Button type="submit" variant="contained" onClick={props.onSubmitHandler}>
                            {props.customSubmitName ? props.customSubmitName : "Search"}
                        </Button>
                    </Grid>
                    <Grid item xs={5} md={5} xl={5} textAlign="center">
                        <Button variant="outlined" type="reset" onClick={props.onCancelHandler}>
                            {props.customCancelName ? props.customCancelName : "Clear"}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default SearchActions;
